import { CompanyShell, Quote, contactLine, useCompanyCompliance } from "@/components/CompanyPage";

export default function CompanySmsConsent() {
  const { c, missing } = useCompanyCompliance();
  return (
    <CompanyShell c={c} missing={missing} kicker="SMS Consent" title={c ? `${c.brand} SMS Opt-In` : ""} testid="company-sms-consent-page">
      {c && <>
        <section>
          <h2 className="font-display text-2xl font-bold text-white mb-3">How you opt in</h2>
          <p>When you call {c.brand} and we miss your call, an automated message plays <span className="text-white font-semibold">before any text is sent</span>.
            Press <span className="font-mono text-orange-400">1</span> to agree to texts about your roofing inquiry, estimate scheduling,
            appointment updates and customer-service follow-up. Press 2 or don't respond and no text is sent; you can leave a voicemail instead.</p>
        </section>
        <section><h2 className="font-display text-2xl font-bold text-white mb-3">Exact phone consent message</h2>
          <Quote testid="company-sms-consent-ivr">"{c.ivr_script}"</Quote></section>
        <section className="space-y-4"><h2 className="font-display text-2xl font-bold text-white">Exact messages</h2>
          <div><p className="text-sm text-white mb-2">First text after pressing 1</p><Quote testid="company-sms-consent-first-sms">{c.first_sms}</Quote></div>
          <div><p className="text-sm text-white mb-2">Reply HELP</p><Quote testid="company-sms-consent-help-sms">{c.help_sms}</Quote></div>
          <div><p className="text-sm text-white mb-2">Reply STOP</p><Quote testid="company-sms-consent-stop-sms">{c.stop_sms}</Quote></div>
        </section>
        <section><h2 className="font-display text-2xl font-bold text-white mb-3">Program details</h2>
          <ul className="list-disc pl-6 space-y-1" data-testid="company-sms-consent-details">
            <li><span className="text-white font-semibold">Sender:</span> {c.brand} ({c.legal_name})</li>
            <li><span className="text-white font-semibold">Purpose:</span> {c.scope}. No marketing texts.</li>
            <li>Message frequency varies. Message and data rates may apply.</li>
            <li>Reply STOP to opt out at any time; reply HELP for help, or {contactLine(c)}.</li>
            <li>Consent is not a condition of any purchase or service.</li>
            <li>{c.brand} will not sell or share your mobile number or SMS consent with third parties for marketing.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ul></section>
        <section><h2 className="font-display text-2xl font-bold text-white mb-3">Policies</h2>
          <ul className="font-mono text-sm space-y-1">
            <li>Privacy Policy: <a href={c.urls.privacy} className="text-orange-400 underline" data-testid="company-sms-consent-privacy-link">{c.urls.privacy}</a></li>
            <li>Terms: <a href={c.urls.terms} className="text-orange-400 underline">{c.urls.terms}</a></li>
          </ul></section>
      </>}
    </CompanyShell>
  );
}
